import ApiBase from '../../ApiBase';

class Assignments extends ApiBase {
    route = '/admin/services/assignments';

    /**
     * @method save
     * @param {array} assignments
     * @return {Promise<*>}
     */
    save = (assignments) => this.patch(null, {assignments}, null, 204);
}

export default new Assignments();
